import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-affiliate-organizations',
  templateUrl: './affiliate-organizations.component.html',
  styleUrls: ['./affiliate-organizations.component.css']
})
export class AffiliateOrganizationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
